const CompanyTypes = {
    LEASE_ACTION_START:"LEASE_ACTION_START",
    LEASE_FETCH_DATA:"LEASE_FETCH_DATA",
    LEASE_FETCH_DATA_FAILED:"LEASE_FETCH_DATA_FAILED",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
}

const LeaseReducer = (state=Initial_state, action) => {
    switch(action.type){
        case CompanyTypes.LEASE_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case CompanyTypes.LEASE_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload,
            }

        case CompanyTypes.LEASE_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
            
        default:
            return state;
    }
};

export default LeaseReducer;